import React, { Component } from "react";
import { Grid } from "@mui/material";
import { connect } from "react-redux";
import CreatePassword from "./CreatePassword";
import ClipLoader from "react-spinners/ClipLoader";
import { moveToOptionsPage } from "../actions/routeactions";
import { resetPasswordBegin } from "../actions/resetpasswordactions";

class ResetPasswordPage extends Component {
  state = {
    currentPassword: "",
    newPassword: "",
  };

  constructor(props) {
    super(props);

    this.changeCurrentPassword = this.changeCurrentPassword.bind(this);
    this.changeNewPassword = this.changeNewPassword.bind(this);
    this.renderButtons = this.renderButtons.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
    this.toOptionsPage = this.toOptionsPage.bind(this);
    this.submit = this.submit.bind(this);
  }

  changeCurrentPassword(e) {
    this.setState({
      currentPassword: e.target.value,
    });
  }

  changeNewPassword(e) {
    this.setState({
      newPassword: e.target.value,
    });
  }

  submit() {
    const { dispatch } = this.props;
    const { currentPassword, newPassword } = this.state;
    dispatch(resetPasswordBegin(currentPassword, newPassword));
  }

  toOptionsPage() {
    const { dispatch } = this.props;
    dispatch(moveToOptionsPage());
  }

  renderButtons() {
    return (
      <React.Fragment>
        <button className="bbe-button" onClick={this.submit}>
          Submit
        </button>
        <p className="hyperlink" onClick={this.toOptionsPage}>
          <u>Back To Options</u>
        </p>
      </React.Fragment>
    );
  }

  renderLoading() {
    return (
      <ClipLoader color="#FFFFFF" sizeUnit={"%"} size={100} loading={true} />
    );
  }

  render() {
    const { loading } = this.props;

    return (
      <Grid container alignItems="center" justifyContent="center">
        <div className="form login_form">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h2>Reset Password</h2>
            </Grid>
            <Grid item xs={12}>
              <label className="label">Current Password</label>
            </Grid>
            <Grid item xs={12}>
              <CreatePassword updatePassword={this.changeCurrentPassword} />
            </Grid>
            <Grid item xs={12}>
              <label className="label">New Password</label>
            </Grid>
            <Grid item xs={12}>
              <CreatePassword updatePassword={this.changeNewPassword} />
            </Grid>
            <Grid item xs={12}>
              {loading ? this.renderLoading() : this.renderButtons()}
            </Grid>
          </Grid>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.resetPassword.loading,
});

export default connect(mapStateToProps)(ResetPasswordPage);
